/* ============================================================
   MILLENNIUM BAZAR — interazioni "Antico Egitto" + TCG reactive
   (reversibile: rimuovere insieme a millennium.css)
   - geroglifici di sfondo che compaiono e scompaiono
   - effetto carta olografica (tilt 3D + riflesso che segue il cursore)
   - parallax sul titolo hero
   ============================================================ */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* 1) sfondo: geroglifici in dissolvenza */
  var GLYPHS = ['𓂀','𓋹','𓆣','𓅓','𓊹','𓉔','𓆄','𓃭','𓊨','𓇋','𓎡','𓁿','𓆓','𓊛','𓏏','𓐍','𓋴','𓃀'];
  function buildGlyphs() {
    if (document.querySelector('.mb-glyphs')) return;
    var layer = document.createElement('div');
    layer.className = 'mb-glyphs';
    layer.setAttribute('aria-hidden', 'true');
    var n = window.innerWidth < 750 ? 16 : 32;
    for (var i = 0; i < n; i++) {
      var s = document.createElement('span');
      s.textContent = GLYPHS[i % GLYPHS.length];
      s.style.left = Math.round(Math.random() * 92 + 2) + '%';
      s.style.top = Math.round(Math.random() * 88 + 4) + '%';
      s.style.fontSize = Math.round(Math.random() * 36 + 40) + 'px';
      s.style.animationDuration = (Math.random() * 6 + 9).toFixed(1) + 's';
      s.style.animationDelay = (Math.random() * 11).toFixed(1) + 's';
      layer.appendChild(s);
    }
    document.body.appendChild(layer);
  }

  /* 2) effetto carta olografica su ogni product card */
  function bindTilt(scope) {
    (scope || document).querySelectorAll('.card-wrapper').forEach(function (w) {
      if (w.__mbTilt) return; w.__mbTilt = true;
      var card = w.querySelector('.card') || w;
      w.addEventListener('pointermove', function (e) {
        var r = w.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width;
        var py = (e.clientY - r.top) / r.height;
        card.style.transform = 'perspective(760px) rotateX(' + ((0.5 - py) * 8).toFixed(2) + 'deg) rotateY(' + ((px - 0.5) * 10).toFixed(2) + 'deg) translateY(-5px)';
        w.style.setProperty('--gx', (px * 100).toFixed(1) + '%');
        w.style.setProperty('--gy', (py * 100).toFixed(1) + '%');
        w.style.setProperty('--ho', '1');
      });
      w.addEventListener('pointerleave', function () {
        card.style.transform = '';
        w.style.setProperty('--ho', '0');
      });
    });
  }

  /* 3) parallax sul titolo hero (.mb-hero con dentro [data-mb-mark]) */
  function bindHero() {
    document.querySelectorAll('.mb-hero').forEach(function (sec) {
      if (sec.__mbHero) return; sec.__mbHero = true;
      var mark = sec.querySelector('[data-mb-mark]');
      if (!mark) return;
      sec.addEventListener('pointermove', function (e) {
        var r = sec.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width - 0.5;
        var py = (e.clientY - r.top) / r.height - 0.5;
        mark.style.transform = 'perspective(900px) rotateY(' + (px * 8).toFixed(2) + 'deg) rotateX(' + (-py * 6).toFixed(2) + 'deg)';
      });
      sec.addEventListener('pointerleave', function () { mark.style.transform = ''; });
    });
  }

  function init(scope) {
    if (!reduce) buildGlyphs();
    bindTilt(scope);
    if (!reduce) bindHero();
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', function () { init(); });
  /* ri-aggancia le card caricate dinamicamente (paginazione, filtri, section editor) */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
